import { FunctionComponent } from "react";
import styled from "styled-components";

import ImagePillContent from "./ImagePillContent";
import { colours } from "@/utils";
import { Device } from "@/utils/device";

const subheading =
  "For Elevate members or alumni who are keen to find their first or next board position.";

const copy = [
  "Delivered by globally renowned experts, this hands-on series is the springboard for unlocking potential, honing skills, and preparing women to not just make it to board roles but be truly impactful in them.",
];

const Title: FunctionComponent = () => {
  return (
    <S.Title>
      Elev<S.ItalicWrap>a</S.ItalicWrap>te
      <S.SmallWrap>
        <i>to the</i>
      </S.SmallWrap>
      <S.BoldWrap>Board</S.BoldWrap>
    </S.Title>
  );
};

const ElevateBoardContent: FunctionComponent = () => {
  return (
    <ImagePillContent
      id="elevate-board"
      href="/elevate"
      title={<Title />}
      subheading={subheading}
      copy={copy}
      linkText="Accelerate your career"
      imagePath="/images/marketing/elevate-board.png"
    />
  );
};

const S = () => {};

S.Title = styled.h2`
  font-size: 7rem;
  font-weight: 100;
  line-height: 6rem;
  color: ${colours.marketingBlue};

  @media (min-width: ${Device.tablet}) {
    font-size: 8rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 10rem;
  }
`;

S.SmallWrap = styled(S.Title)`
  font-size: 2rem;
  line-height: 2rem;

  @media (min-width: ${Device.tablet}) {
    font-size: 3rem;
    line-height: 4rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 4rem;
    line-height: 6rem;
  }
`;

S.BoldWrap = styled(S.Title)`
  font-family:
    HK Grotesk,
    sans-serif;
  font-weight: 800;
  line-height: 2rem;
  letter-spacing: -2px;
  padding-left: 5rem;
  margin-bottom: 6rem;

  @media (min-width: ${Device.tablet}) {
    line-height: 0rem;
    padding-left: 8rem;
    margin-bottom: 7rem;
  }

  @media (min-width: ${Device.desktop}) {
    padding-left: 10rem;
    margin-bottom: 9rem;
  }
`;

S.ItalicWrap = styled.span`
  font-style: italic;
  margin-left: -10px;
`;

export default ElevateBoardContent;
